import Participants from './Participants';

export default Participants;
